module.exports = __webpack_public_path__ + "img/home@2x-100.e71aa547.jpg";